import './assets/main.css'
import './assets/theme.css'
import './assets/workflow-theme.scss'
import './assets/styles/design-tokens.scss'
import 'ant-design-vue/dist/reset.css'
import 'nprogress/nprogress.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import { setupRouterGuards } from './router/guards'
import { setupErrorHandler } from './utils/errorHandler'
import { i18n } from './locales'
import themeManager from './utils/themeManager'
import { setupDirectives } from './directives'

const app = createApp(App)

// 0. 初始化主题管理器
themeManager.setTheme(themeManager.getTheme())

// 1. 设置全局错误处理
setupErrorHandler(app)

// 2. 使用插件
app.use(createPinia())
app.use(router)
app.use(i18n)

// 3. 设置路由守卫（登录验证、页面标题、进度条）
setupRouterGuards(router)

// 4. 注册全局指令
setupDirectives(app)

app.mount('#app')
